import {
  fetchAllDesignations,
  fetchAllDesignationsUnfiltered,
} from "@/services/designation.service";
import { useQuery } from "@tanstack/react-query";

export const designationKeys = {
  all: ["designations"] as const,
  lists: () => [...designationKeys.all, "list"] as const,
};

export const useAllDesignationsQuery = () => {
  return useQuery({
    queryKey: designationKeys.lists(),
    queryFn: () => fetchAllDesignations(),
  });
};

export const useAllDesignationsUnfilteredQuery = () => {
  return useQuery({
    queryKey: [...designationKeys.all, "unfiltered"],
    queryFn: () => fetchAllDesignationsUnfiltered(),
  });
};
